export default __webpack_public_path__ + "static/media/elevation.5d6f3742.svg";